import React, { createContext, useContext, useState } from 'react';

export interface StatusStep {
  step: number;
  description: string;
  status: 'completed' | 'in_progress' | 'pending' | 'failed';
}

export interface StatusTemplateData {
  statusSteps: StatusStep[];
  templateTitle: string;
}

interface StatusTemplateContextValue {
  statusTemplate: StatusTemplateData | null;
  setStatusTemplate: (data: StatusTemplateData | null) => void;
}

const StatusTemplateContext = createContext<StatusTemplateContextValue>({
  statusTemplate: null,
  setStatusTemplate: () => {},
});

export const StatusTemplateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [statusTemplate, setStatusTemplate] = useState<StatusTemplateData | null>(null);
  return (
    <StatusTemplateContext.Provider value={{ statusTemplate, setStatusTemplate }}>
      {children}
    </StatusTemplateContext.Provider>
  );
};

export const useStatusTemplate = () => useContext(StatusTemplateContext);
